import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitiesTableFilters from 'components/organisms/TableFilters/EntitiesTableFilters/EntitiesTableFilters';

const StyledDealflowEntitiesTableFilters = styled(EntitiesTableFilters)`
  ${ComponentStyles}
`;

StyledDealflowEntitiesTableFilters.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowEntitiesTableFilters;
